// frontend/src/components/Footer.js
import React from 'react';
import { Box, Grid, Typography, Link } from '@mui/material';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                py: 1.75,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                mt: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
                backdropFilter: 'blur(6px)',
            }}
        >
            <Grid container justifyContent="center" rowSpacing={0.75}>
                <Grid item xs={12} sm={6} textAlign="center">
                    <Typography variant="body2" color="text.secondary">
                        &copy; {new Date().getFullYear()} IV Creative Limited. All rights reserved.
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} textAlign="center">
                    <Typography variant="body2" color="text.secondary">
                        <Link href="https://iv-creative.co.uk/terms-and-conditions/" color="inherit" underline="hover">
                            Terms and Conditions
                        </Link>
                        {' | '}
                        <Link href="https://iv-creative.co.uk/privacy-policy/" color="inherit" underline="hover">
                            Privacy Policy
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Footer;
